/**
 * ControlPage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// application
import {updateViewProperty} from "../../redux/view/actions";
import AdminConnectionPanel from "./AdminConnectionPanel";
import AdminSensorStatusPanel from "./AdminSensorStatusPanel";
import AdminStoryStatusPanel from "./AdminStoryStatusPanel";
import AdminStorylinePanel from "./AdminStorylinePanel";
import AdminPropertyStatePanel from "./AdminPropertyStatePanel";


const tabs = [
    {
        label: "Verbindungen",
        getVisibility: (userPrivileges, parameterMap) => userPrivileges["openControlDashboard"],
        element: AdminConnectionPanel
    },
    {
        label: "Sensoren",
        getVisibility: (userPrivileges, parameterMap) => userPrivileges["openControlDashboard"],
        element: AdminSensorStatusPanel
    },
    {
        label: "Stories",
        getVisibility: (userPrivileges, parameterMap) => userPrivileges["openControlDashboard"],
        element: AdminStoryStatusPanel
    },
    {
        label: "Aktionen",
        getVisibility: (userPrivileges, parameterMap) => userPrivileges["openControlDashboard"],
        element: AdminStorylinePanel
    },
    {
        label: "Merkmale",
        getVisibility: (userPrivileges, parameterMap) => userPrivileges["openControlDashboard"],
        element: AdminPropertyStatePanel
    }
];


/**
 * ControlPage is the page for the control center
 */
class ControlPage extends React.Component {

    changeTab(index) {
        this.props.updateViewProperty("controlSection", "tabIndex", index);
    }

    render() {

        return (
            <div>
                <Tabs value={this.props.tabIndex} onChange={(event, index) => this.changeTab(index)}>
                    {this.props.tabs.map(tab => <Tab key={tab.index} label={tab.label} value={tab.index} />)}
                </Tabs>

                <div className={this.props.classes.tabContent}>
                    {this.renderCurrentTab()}
                </div>
            </div>
        );
    }

    renderCurrentTab() {

        const tabs = this.props.tabs.filter(
            tab => tab.index === this.props.tabIndex
        );
        const tab = tabs[0];
        if (!tab) return undefined;

        const TabElement = tab.element;
        return <TabElement/>;
    }
}


const styles = theme => ({
    tabContent: {
        marginTop: theme.spacing.unit
    }
});

const mapStateToProps = state => {

    const userPrivileges = state.authorization.userPrivileges || {};
    const parameterMap = state.configuration.parameterMap;

    return {
        tabs: tabs.map(
            // add tab indexes automatically
            (tab, index) => ({...tab, index: index})
        ).filter(
            // and only show tabs the current user is allowed to see
            tab => tab.getVisibility(userPrivileges, parameterMap)
        ),
        tabIndex: state.view.controlSection.tabIndex || 0
    }
};

export default connect(mapStateToProps, {updateViewProperty})(withStyles(styles)(ControlPage));
